<script setup lang="ts">
import { useUserStore } from "@/stores/user.ts";
import { ThemeAvatarUploader, ThemeButton } from "@/ui-components";
import { storeToRefs } from "pinia";
import { computed } from "vue";
import { useRoute, useRouter } from "vue-router";
import UserIcon from "@/assets/icons/user.svg?component";

const route = useRoute();
const router = useRouter();
const userStore = useUserStore();
const { userProfile } = storeToRefs(userStore);

const monogram = computed(() => {
  const p = userProfile.value;
  return p.firstName && p.lastName
    ? (p.firstName.charAt(0) + p.lastName.charAt(0)).toUpperCase()
    : null;
});

const userPicture = computed(() => `/api/user/profile-picture/${userProfile.value.externalId}`);

const variant = computed(() =>
  ((route.name as string) ?? "").includes("bookmark") ? "light" : "primary",
);
</script>

<template>
  <ThemeButton
    v-if="userProfile.externalIdentityProvider || !userProfile.pictureUploaded"
    class="me-1"
    :variant="variant"
    :fab="true"
    :icon-center="userProfile.externalIdentityProvider ? UserIcon : null"
    :char="!userProfile.externalIdentityProvider && monogram ? monogram : undefined"
    :width-icon="36"
    aria-label="Profil"
    link
    :to="{ name: 'user' }"
  />
  <ThemeAvatarUploader
    v-else
    class="me-1"
    :size="40"
    image-class="border-0 cursor-pointer"
    :model-value="userPicture"
    :readonly="true"
    @click="router.push({ name: 'user' })"
  />
</template>
